import { Expl } from "./components/Expl"

export const trivia = [
	// NotCC
	<>
		NotCC has built-in help! If you see a <Expl>good job!</Expl> button, press
		it to learn about the option by it.
	</>,
	<>
		ExaCC is named after{" "}
		<a href="https://wiki.bitbusters.club/SuperCC">SuperCC</a>/SuCC, an
		optimization tool for MS and Lynx rulesets.
	</>,
	<>
		There are two tilesets called CGA:{" "}
		<a href="https://forum.bitbusters.club/thread-2799.html">
			the 4-color CC1 tileset made by Sickly
		</a>
		, and the 16-color CC2 tileset made by G lander specifically for NotCC.
	</>,
	<>
		NotCC's game logic, called libnotcc, is written in C and is separate from
		this GUI. If you want, you can make your own interface based on libnotcc!
	</>,
	// CC2 mechanics
	<>
		CC2 has its own weird programming language called{" "}
		<a href="https://wiki.bitbusters.club/C2G">C2G</a>.
	</>,
	<>
		In CC2, teeth always start moving on the 4th tick, while in MS and Lynx this
		varies between level attempts.
	</>,
	<>
		There are multiple glitches which are not allowed in scoreboard reports. One
		of them is a variation of the{" "}
		<a href="https://wiki.bitbusters.club/Despawning_and_Respawning_Glitch">
			{" "}
			despawning and respawning glitch
		</a>
		, in which a player or monster is "moved" from one level to another.
	</>,
	<>
		There are multiple glitches which are not allowed in scoreboard reports. One
		of them is{" "}
		<a href="https://wiki.bitbusters.club/Explosion_Sneaking">
			explosion sneaking
		</a>
		, where a player can move at a specific moment to not die when being near
		exploding dynamite.
	</>,
	<>
		There are multiple glitches which are not allowed in scoreboard reports. One
		of them is{" "}
		<a href="https://wiki.bitbusters.club/Simultaneous_Character_Movement">
			simultaneous character movement
		</a>
		, where multiple player characters can be moved at once, by either
		keymashing or utilizing key repeat.
	</>,
	// Community
	<>
		You can submit your level scores to{" "}
		<a href="https://scores.bitbusters.club/">the community scoreboard</a> to be
		tracked and compared against other people's scores.
	</>,
	<>
		There is a website for submitting CC2 level routes called{" "}
		<a href="https://glander.club/railroad">Railroad</a>. It is the CC2 version
		of the <a href="https://wiki.bitbusters.club/Public_TWS">public TWS</a>.
	</>,
	<>
		There is another CC2 emulator called{" "}
		<a href="https://c.eev.ee/lexys-labyrinth">Lexy's Labyrinth</a>! Unlike
		NotCC, it has a built-in level editor and custom elements, however it isn't
		scoreboard legal.
	</>,
	<>
		There is an optimization tool called{" "}
		<a href="http://cc-optimization.byethost12.com/">
			Melinda Vicinity Searcher
		</a>
		! It has advanced support for computer-based solution search, and it even
		inspired ExaCC's tree and graph models!
	</>,
	<>
		If you ever wanted to design your own CC2 levels, try{" "}
		<a href="https://cctools.zrax.net/">CC2Edit</a>! It is a fully featured CC2
		level editor with playtesting support.
	</>,
	<>
		On January 30th 2024, a chipster by the name of Sharpeye acquired record
		(bold) times for all CC1 levels in the Steam ruleset. Gz, Sharpeye!
	</>,
	<>
		You can submit your own trivia! Join the{" "}
		<a href="https://discord.gg/Xd4dUY9">Bit Busters Club Discord Server</a> and
		tell us your suggestion in #dev-projects.
	</>,
	<>
		Multiple NotCC features, like ExaCC's timeline and custom sound effects were
		suggested by community members. So, if you have any ideas on how to improve
		NotCC, submit them to{" "}
		<a href="https://github.com/TheGLander/NotCC/issues/new">GitHub</a> or the{" "}
		<a href="https://discord.gg/Xd4dUY9">Bit Busters Club Discord Server</a>!
	</>,
]
